import React, { useRef } from 'react';
import Box from '@mui/material/Box';
import { Breadcrumbs, ICrumbs } from 'src/components/profileComponents/Breadcrumbs';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';

interface UserProps {
  crumbs: ICrumbs[],
  title: string | React.ReactNode,
}
export const UsersPageWrapper: React.FC<UserProps> = ({ crumbs, title, children }) => {
  const pageWrapperRef = useRef<HTMLDivElement>(null);
  useGlobalGrid(pageWrapperRef);
  return (
    <Box py="32px" px="32px" height="100%" ref={pageWrapperRef}>
      <Box display="flex" flexWrap="nowrap">
        <Box fontSize="32px" mr="24px" fontWeight={600} lineHeight="44px" width="100%">
          {title}
        </Box>
      </Box>
      <Breadcrumbs crumbs={crumbs} />
      {children}
    </Box>
  );
};
